import React from 'react';
import { useAuth } from '../context/AuthContext';

// Ana sayfanın en üstünde, yalnızca giriş yapmamış ziyaretçiye çizilen boş
// yer tutucu. İçeriğini panelden yazılan özel kod (CSS/JS) doldurur; kimlik
// bu yüzden bir sözleşmedir ve yeniden adlandırılmaz.
export const GUEST_WELCOME_ID = 'not-logged-welcome';

/**
 * Oturum durumu bilinmeden çizilmez: jetonu olan üye sayfayı yenilediğinde
 * `/auth/me` yanıtı gelene kadar `user` boştur ve karşılama bir an görünüp
 * kaybolurdu.
 *
 * Varsayılan görünümde yer kaplamaz (`display: contents`, App.css): kabuklar
 * içeriği `gap`li bir sütunda dizer ve boş bir kutu üstte fazladan boşluk
 * bırakırdı. Kural özgüllüksüzdür (`:where`), panelden yazılan her kural
 * onu ezer.
 */
const GuestWelcomeSlot = () => {
  const { user, ready } = useAuth();
  if (!ready || user) return null;
  return <div id={GUEST_WELCOME_ID} />;
};

export default GuestWelcomeSlot;
